<template>

    <div>

        <h2 class="section-title">Kontakt</h2>

        <p class="section-intro">
            Interesse an einer Zusammenarbeit oder Fragen zu meinen Leistungen?
            Ich freue mich auf eine Nachricht.
        </p>

        <div class="row mt-4">

            <!-- Kontaktinfos -->
            <div class="col-12 col-md-4 mb-4">

                <div class="contact-info">

                    <div class="contact-item">
                        <i class="fa-solid fa-user"></i>
                        <span>Daniel Wiesner</span>
                    </div>

                    <div class="contact-item">
                        <i class="fa-solid fa-envelope"></i>
                        <a href="mailto:office@wiesnerd.at">office@wiesnerd.at</a>
                    </div>

                    <div class="contact-item">
                        <i class="fa-solid fa-location-dot"></i>
                        <span>Tulpenweg 3<br>5121 St. Radegund<br>Österreich</span>
                    </div>

                </div>

            </div>

            <!-- Kontaktformular -->
            <div class="col-12 col-md-8 mb-4">

                <form @submit.prevent="submitForm" class="contact-form">

                    <div class="row">

                        <div class="col-12 col-sm-6 mb-3">
                            <label for="name">Name *</label>
                            <input
                                type="text"
                                id="name"
                                class="form-control"
                                v-model="form.name"
                                required
                                autocomplete="name"
                            >
                        </div>

                        <div class="col-12 col-sm-6 mb-3">
                            <label for="email">E-Mail *</label>
                            <input
                                type="email"
                                id="email"
                                class="form-control"
                                v-model="form.email"
                                required
                                autocomplete="email"
                            >
                        </div>

                    </div>

                    <div class="mb-3">
                        <label for="subject">Betreff</label>
                        <input
                            type="text"
                            id="subject"
                            class="form-control"
                            v-model="form.subject"
                        >
                    </div>

                    <div class="mb-3">
                        <label for="message">Nachricht *</label>
                        <textarea
                            id="message"
                            class="form-control"
                            rows="5"
                            v-model="form.message"
                            required
                        ></textarea>
                    </div>

                    <!-- Honeypot Spam-Schutz: für Menschen unsichtbar -->
                    <div class="hp-field" aria-hidden="true">
                        <input type="text" name="website" v-model="form.honeypot" tabindex="-1" autocomplete="off">
                    </div>

                    <button type="submit" class="btn-submit" :disabled="sending">
                        <i class="fa-solid fa-paper-plane me-2"></i>
                        {{ sending ? 'Wird gesendet...' : 'Nachricht senden' }}
                    </button>

                    <p v-if="successMessage" class="success-msg mt-3">
                        {{ successMessage }}
                    </p>

                    <p v-if="errorMessage" class="error-msg mt-3">
                        {{ errorMessage }}
                    </p>

                </form>

            </div>

        </div>

    </div>

</template>

<script>

    const WEBHOOK_URL = 'https://n8n.wiesnerd.at/webhook/kontakt-wiesnerd'

    export default {

        name: 'TheContactComponent',

        data() {

            return {

                sending: false,
                successMessage: '',
                errorMessage: '',
                form: {
                    name: '',
                    email: '',
                    subject: '',
                    message: '',
                    honeypot: '',
                },

            }

        },

        methods: {

            async submitForm() {

                // Honeypot ausgefüllt = Bot, lautlos abbrechen
                if (this.form.honeypot) return

                this.sending = true
                this.successMessage = ''
                this.errorMessage = ''

                try {

                    const response = await fetch(WEBHOOK_URL, {

                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            name: this.form.name,
                            email: this.form.email,
                            subject: this.form.subject,
                            message: this.form.message,
                        }),

                    })

                    if (!response.ok) throw new Error('Serverfehler')

                    this.successMessage = 'Danke für Ihre Nachricht. Ich melde mich so bald wie möglich.'
                    this.form = { name: '', email: '', subject: '', message: '', honeypot: '' }

                } catch (e) {

                    this.errorMessage = 'Beim Senden ist ein Fehler aufgetreten. Bitte schreiben Sie direkt an office@wiesnerd.at'

                } finally {

                    this.sending = false

                }

            },

        },

    }

</script>

<style scoped>

    .contact-info {

        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        padding-top: 0.5rem;

    }

    .contact-item {

        display: flex;
        align-items: flex-start;
        gap: 0.85rem;
        color: #3a4a5a;

    }

    .contact-item i {

        color: #0B5FA5;
        margin-top: 0.15rem;
        min-width: 16px;

    }

    .contact-item a {

        color: #0B5FA5;
        text-decoration: none;

    }

    .contact-item a:hover {

        text-decoration: underline;

    }

    .contact-form label {

        font-size: 0.88rem;
        font-weight: 500;
        color: #4a5a6a;
        margin-bottom: 0.35rem;
        display: block;

    }

    .contact-form .form-control {

        border: 1px solid #dde4ec;
        border-radius: 6px;
        font-size: 0.92rem;
        transition: border-color 0.2s ease;

    }

    .contact-form .form-control:focus {

        border-color: #0B5FA5;
        box-shadow: 0 0 0 3px rgba(11, 95, 165, 0.1);

    }

    /* Honeypot: komplett versteckt */
    .hp-field {

        position: absolute;
        left: -9999px;
        opacity: 0;
        pointer-events: none;

    }

    .btn-submit {

        background: #0B5FA5;
        color: #fff;
        border: none;
        padding: 0.7rem 2rem;
        border-radius: 6px;
        font-size: 0.92rem;
        cursor: pointer;
        transition: background 0.2s ease;

    }

    .btn-submit:hover:not(:disabled) {

        background: #0a52910;

    }

    .btn-submit:disabled {

        opacity: 0.65;
        cursor: not-allowed;

    }

    .success-msg {

        color: #1a7a40;
        font-size: 0.9rem;

    }

    .error-msg {

        color: #a02020;
        font-size: 0.9rem;

    }

</style>
